import styled, { css } from 'styled-components';
import BackImage from '~/assets/images/back.jpeg';

type RestaurantIconProps = {
  image: string;
};

type WrapperPositionProps = {
  cover: string;
  turnHasCome: boolean;
};

type ContentInfoProps = {
  hasPrediction: boolean;
};

export const Container = styled.div`
  width: 100%;

  border-radius: 1rem;
`;

export const WrapperPosition = styled.div<WrapperPositionProps>`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding-block: 1rem;

  border-radius: 1rem 1rem 0 0;

  ${({ theme, cover, turnHasCome }) => css`
    color: ${theme.colors.white};

    ${cover && css`
      background: ${turnHasCome ? 'linear-gradient(0deg, rgba(31, 120, 67, 0.90), rgba(31, 120, 67, 0.90))' : 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6))'},
        url(${cover}) no-repeat center;
      background-size: cover;
    `}
  `}
`;

export const TextPosition = styled.strong`
  font-size: 4rem;
`;

export const TextTurnHasCome = styled.strong`
  font-size: 1.8rem;
  line-height: 1.5rem;
`;

export const DescriptionTurnHasCome = styled.strong`
  font-size: 1.5rem;
  ${({ theme }) => css`
    font-weight: ${theme.font.normal};
  `}
`;

export const DescriptionPosition = styled.span`
  font-size: 1.4rem;
  text-align: center;
`;

export const WrapperRestaurantInfo = styled.div`
  width: 100%;

  padding: 1.5rem 3rem;
  border-radius: 0 0 1rem 1rem;

  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `}
`;

export const ContentInfo = styled.div<ContentInfoProps>`
  display: flex;
  justify-content: space-between;

  ${({ hasPrediction }) => css`
    margin-bottom: ${hasPrediction ? '1rem' : '0'};
  `}
`;

export const RestaurantIcon = styled.div<RestaurantIconProps>`
  width: 4rem;
  height: 4rem;
  border-radius: 50% 50%;

  ${({ image }) => css`
    ${image && css`
      background: url(${image}) no-repeat center;
      background-size: cover;
    `}
  `}
`;

export const TextInfoBox = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;

  margin-left: 1.5rem;
`;

export const RestaurantTitle = styled.span`
  font-size: 1.6rem;
  font-weight: 700;
`;

export const InfoPosition = styled.p`
  font-size: 1.2rem;
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
  `}
`;

export const SpanInfoMedium = styled.span`
  font-size: 1.2rem;
  margin-top: 0.5rem;
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};

    b {
      color: ${theme.colors.black};
    }
  `}
`;

export const ContentHasCome = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  gap: 1rem;

  padding: 1rem 1.5rem;
`;

export const ContentTolerance = styled.div`
  margin-top: 1.5rem;
`;

export const ToleranceText = styled.div`
  font-size: 1.5rem;
  ${({ theme }) => css`
    color: ${theme.colors.primary};

    > span {
      font-weight: ${theme.font.bold};
    }
  `}
`;
